export enum StoreLocatorViews {
  LIST_VIEW = 'listView',
  MAP_VIEW = 'mapView',
}
